import _regeneratorRuntime from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { isEmpty } from 'element-ui/src/utils/util';
import { getOferta, getDetalleOferta } from '@/routes/api/views/flujo';
import ElOfertaDownSolicitudDefault from "./defaults/partsSolicitud/OfertaDownSolicitudDefault";
import ElOfertaUpSolicitudDefault from "./defaults/partsSolicitud/OfertaUpSolicitudDefault";
import ElOfertaUpDescuentosDefault from "./defaults/partsDescuentos/OfertaUpDescuentosDefault";
import baseFormFlujo from "@/components/Flujo/Templates/baseFormFlujo";
import { mapGetters } from "vuex";
export default {
  name: 'PzBaseOfertas',
  components: {},
  mixins: [baseFormFlujo],
  provide: function provide() {
    return {
      ofertas: this
    };
  },
  data: function data() {
    return {
      reference: 'otras_ofertas',
      elOfertaView: '',
      best: '',
      montos_array: '',
      cuotas_array: '',
      down: false,
      mycomponents: [ElOfertaUpSolicitudDefault.name, ElOfertaDownSolicitudDefault.name, ElOfertaUpDescuentosDefault.name],
      detalle: '',
      viewDetalle: false,
      viewInfo: false,
      texto: ''
    };
  },
  computed: _objectSpread({}, mapGetters(["form_product"])),
  created: function created() {
    this.$store.dispatch('loader/up', {
      trigger: this.$options.name
    });
    if (this.producto.needsDocuments) {
      this.getOfertaView('descuentos');
    } else {
      this.getOfertaView('solicitud');
    }
    this.obtenerOferta();
  },
  methods: {
    getOfertaView: function getOfertaView(tipe) {
      this.elOfertaView = tipe + '-' + this.extraData.ofertaView;
    },
    obtenerOferta: function obtenerOferta() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getOferta(_this.loan, {
                withAdditionals: _this.extraData.withAdditionals
              }).then(function (res) {
                _this.best = res.data;
                if (!isEmpty(res.data.adicionales)) {
                  _this.viewInfo = _this.form_product.route_params.view_info;
                  _this.texto = _this.form_product.route_params.texto;
                  _this.cuotas_array = res.data.adicionales.cuotas;
                  _this.montos_array = res.data.adicionales.montos;
                  _this.down = _this.extraData.withAdditionals;
                }
                _this.viewDetalleOferta();
              }).catch(function () {
                _this.$router.push({
                  name: 'Rejected'
                });
              }).finally(function () {
                _this.$store.dispatch('loader/down', {
                  trigger: _this.$options.name
                });
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    viewDetalleOferta: function viewDetalleOferta() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$store.dispatch('loader/up', {
                trigger: _this2.$options.name
              });
              _context2.next = 3;
              return getDetalleOferta({
                loan: _this2.loan,
                monto: _this2.best.monto
              }).then(function (res) {
                if (!isEmpty(res.data.detalle)) {
                  _this2.detalle = res.data.detalle;
                  _this2.viewDetalle = true;
                }
              }).catch(function () {
                _this2.$router.push({
                  name: 'Rejected'
                });
              }).finally(function () {
                _this2.$store.dispatch('loader/down', {
                  trigger: _this2.$options.name
                });
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};